import * as Sentry from '@sentry/react';
import api from 'api';
import store from 'store';

import IAsync from 'types/IAsync';
import INodeAgent from 'types/INodeAgent';

function setNodesAsync(nodesAsync: IAsync<INodeAgent[]>) {
  store.setState({ nodesAsync });
}

export default function fetchNodes() {
  const async = store.getState().nodesAsync;

  switch (async.status) {
    case 'PENDING':
    case 'REFRESH':
      // Already fetching
      return;
    case 'INIT':
    case 'ERROR':
      setNodesAsync({ status: 'PENDING' });
      break;
    case 'SUCCESS':
      setNodesAsync({ status: 'REFRESH', data: async.data });
      break;
  }

  api
    .get(`node-agents`)
    .json()
    .then(
      (data) => {
        setNodesAsync({ status: 'SUCCESS', data: data as INodeAgent[] });
      },
      (error) => {
        Sentry.captureException(error);
        setNodesAsync({ status: 'ERROR' });
      },
    );
}
